import React from 'react';

const ApiKeyTest = () => {
  const apiKey = import.meta.env.VITE_OPENAI_API_KEY;
  const hasApiKey = !!apiKey;
  const keyLength = apiKey ? apiKey.length : 0;
  const keyStart = apiKey ? apiKey.substring(0, 10) : 'N/A';
  const keyEnd = apiKey ? apiKey.substring(apiKey.length - 10) : 'N/A';

  const testAPIKey = async () => {
    if (!apiKey) {
      alert('No API key found in environment variables');
      return;
    }

    try {
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiKey}`
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [{ role: 'user', content: 'Hello' }],
          max_tokens: 5,
          temperature: 0
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert(`✅ API Key Works!\n\nResponse: ${data.choices[0].message.content}`);
      } else {
        alert(`❌ API Error\n\nStatus: ${response.status}\nError: ${JSON.stringify(data, null, 2)}`);
      }
    } catch (error) {
      alert(`❌ Network Error\n\nError: ${error.message}`);
    }
  };

  return (
    <div className="bg-yellow-100 border border-yellow-400 rounded-lg p-4 m-4">
      <h3 className="font-semibold text-yellow-800 mb-2">🔍 Live API Key Test</h3>
      <div className="text-sm space-y-2">
        <p><strong>Has API Key:</strong> {hasApiKey ? '✅ Yes' : '❌ No'}</p>
        <p><strong>Key Length:</strong> {keyLength}</p>
        <p><strong>Key Start:</strong> {keyStart}...</p>
        <p><strong>Key End:</strong> ...{keyEnd}</p>
        <p><strong>Full Key:</strong> {apiKey}</p>
        <p><strong>Environment:</strong> {import.meta.env.MODE}</p>
        
        <button 
          onClick={testAPIKey}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mt-2"
        >
          Test This API Key
        </button>
      </div>
    </div>
  );
};

export default ApiKeyTest;
